import axios, { Canceler } from 'axios';
import env from '@beam-australia/react-env';

export const geoip = {
  get: {
    action: () => axios.get(`https://api.ipgeolocation.io/ipgeo?apiKey=${env('INFOIP_TOKEN')}`),
    cancel: (() => null) as Canceler,
  },
};
